var render, staticRenderFns
import script from "./MyCascader.vue?vue&type=script&lang=js&"
export * from "./MyCascader.vue?vue&type=script&lang=js&"
import style0 from "./MyCascader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8b3fcf')) {
      api.createRecord('5f8b3fcf', component.options)
    } else {
      api.reload('5f8b3fcf', component.options)
    }
    
  }
}
component.options.__file = "src/components/MyCascader/MyCascader.vue"
export default component.exports